var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1,
    viewBox: "0 0 32 40",
    xmlSpace: "preserve",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m16 2c-2.3909 0-4.6833 0.9649-6.3691 2.6777-1.686 1.7118-2.6309 4.0315-2.6309 6.4473v1.127c0 5.9847 2.4036 11.712 6.6582 15.861a1.0001 1.0001 0 0 0 0 2e-3c0.96384 0.93884 1.6445 1.6016 1.6445 1.6016a1.0001 1.0001 0 0 0 1.3945 0s0.68069-0.66272 1.6445-1.6016a1.0001 1.0001 0 0 0 0 -2e-3c4.2546-4.1498 6.6582-9.8766 6.6582-15.861v-1.127c0-2.4158-0.94488-4.7354-2.6309-6.4473-1.6859-1.7128-3.9782-2.6777-6.3691-2.6777zm0 2c1.8531 0 3.6292 0.74687 4.9434 2.082a1.0001 1.0001 0 0 0 2e-3 0c1.314 1.3342 2.0546 3.1488 2.0546 5.043v1.127c0 5.4493-2.1893 10.66-6.0547 14.43-0.55493 0.54054-0.65407 0.63801-0.94531 0.92188-0.29124-0.28387-0.39038-0.38134-0.94531-0.92188-3.8654-3.7702-6.0547-8.9804-6.0547-14.43v-1.127c0-1.8942 0.74066-3.7088 2.0547-5.043a1.0001 1.0001 0 0 0 2e-3 0c1.3141-1.3352 3.0902-2.082 4.9433-2.082z",
    clipRule: "nonzero",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    fillRule: "nonzero",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 7c-2.1973 0-4 1.8027-4 4 0 2.1973 1.8027 4 4 4s4-1.8027 4-4c0-2.1973-1.8027-4-4-4zm0 2c1.1164 0 2 0.88359 2 2 0 1.1164-0.88359 2-2 2s-2-0.88359-2-2c0-1.1164 0.88359-2 2-2z",
    clipRule: "nonzero",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    fillRule: "nonzero",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoc);
export default __webpack_public_path__ + "static/media/Icon_loc.c8fdf610dcd07d3a70c7f446b6164b96.svg";
export { ForwardRef as ReactComponent };